import type { FC } from 'react'

import { cn } from '@/lib/utils'

/** The hand-drawn underline from the original Localboost site, redrawn as a scalable stroke. */
export const UNDERLINE_PATH = 'm2.88,7.71c140-8.78,175.18-3.93,249,1.46'

interface BrandUnderlineProps {
    className?: string
}

export const BrandUnderline: FC<BrandUnderlineProps> = ({ className }) => {
    return (
        <svg
            viewBox='0 0 254.76 12.05'
            preserveAspectRatio='none'
            aria-hidden='true'
            focusable='false'
            className={cn('pointer-events-none absolute left-0 h-[0.2em] w-full overflow-visible', className)}
        >
            <path
                d={UNDERLINE_PATH}
                pathLength={1}
                fill='none'
                stroke='currentColor'
                strokeLinecap='round'
                vectorEffect='non-scaling-stroke'
                data-underline=''
                style={{ strokeWidth: '0.075em' }}
            />
        </svg>
    )
}
